import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth.tsx';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { authenticated } = useAuth();

  // Still checking session
  if (authenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-brand-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
